(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7497],{

/***/ 25655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49177);

var messages = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessages */ .vU)({
    required: {
        id: "validation.required"
    },
    minLength: {
        id: "validation.min"
    },
    maxLength: {
        id: "validation.max"
    },
    invalid: {
        id: "validation.invalid"
    },
    fillField: {
        id: "validation.fill-field"
    },
    validEmail: {
        id: "login.valid-email"
    },
    pleaseEmail: {
        id: "subscription.please-enter-your-email"
    },
    pleaseEnterPassword: {
        id: "subscription.please-enter-password"
    },
    passwordLength: {
        id: "global.password-length"
    },
    subscriptionRepeatPassword: {
        id: "subscription.repeat-password"
    },
    legalTerms: {
        id: "legal.terms-validation"
    },
    passwordDifferent: {
        id: "login.password-different"
    },
    paxNames: {
        id: "error.room-names"
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (messages);


/***/ }),

/***/ 59896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZE": function() { return /* binding */ getJsonLd; }
});

// UNUSED EXPORTS: setJsonLdAccommodation, setJsonLdBreadcrumb, setSameAsByMarket

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./client/components/JsonLd/constants.js
var jsonld = {
    "@context": "https://schema.org",
    "@type": "Organization",
    address: {
        "@type": "PostalAddress",
        addressCountry: "ES",
        addressLocality: "Barcelona",
        addressRegion: "Barcelona",
        postalCode: "08010",
        streetAddress: "Ronda Sant Pere 17, 3\xba 4\xaa"
    },
    founders: [
        {
            "@type": "Person",
            name: "Luis Osorio Sol\xe9"
        },
        {
            "@type": "Person",
            name: "Francesc L\xf3pez Castellet"
        },
        {
            "@type": "Person",
            name: "Ra\xfal Mor\xf3n Sillero"
        }, 
    ],
    foundingDate: "2015-01-29",
    foundingLocation: "Barcelona",
    legalName: "Stayforlong S.L.",
    logo: {
        "@type": "ImageObject",
        caption: "Stayforlong logo",
        url: "https://static.stayforlong.com/web/images/sfl-logo-mobile.jpg"
    },
    name: "Stayforlong",
    url: "https://www.stayforlong.com"
};
var descriptions = {
    es: "Stayforlong es un sitio web de reservas hoteleras especializado en las reservas de larga estancia. Se encuentra presente en 22 pa\xedses distintos y ofrece a sus clientes una cartera formada por m\xe1s de 720.000 establecimientos hoteleros. Stayforlong tiene su sede en la ciudad de Barcelona.",
    de: "Stayforlong ist eine Hotelreservierungswebseite spezialisiert auf Langzeitaufenthalte. Wir sind pr\xe4sent in 22 verschiedenen L\xe4ndern und bieten unseren Kunden ein Portfolio von mehr als 720.000 Hotels. Stayforlong hat den Hauptsitz in Barcelona.",
    fr: "Stayforlong est un portail de r\xe9servation d'h\xf4tels sp\xe9cialis\xe9 dans les longs s\xe9jours.Nous sommes pr\xe9sents dans 22 pays et proposons \xe0 nos utilisateurs plus de 720.000 h\xf4tels diff\xe9rents.",
    uk: "Stayforlong is a hotel reservation portal specialized in long stays. We are present in 22 countries and offer to our clients more than 720.000 different hotels. Stayforlong's headquarter is located in Barcelona, Spain.",
    pt: "Stayforlong \xe9 um portal de reservas de hot\xe9is especializado em estadias longas. Estamos presentes em 22 pa\xedses e oferecemos aos nossos usu\xe1rios mais de 720.000 hot\xe9is diferentes."
};
var sameAs = [
    "https://www.facebook.com/stayforlong",
    "https://www.instagram.com/stayforlong",
    "https://www.youtube.com/channel/UCXY0iWptc19iyKlVqkK1ZGw", 
];

// EXTERNAL MODULE: ./src/constants/countries.ts
var countries = __webpack_require__(83404);
;// CONCATENATED MODULE: ./client/components/JsonLd/mappers.js

function setAddress(param) {
    var street = param.street, locality = param.locality, region = param.region, _country = param.country, country = _country === void 0 ? DEFAULT_COUNTRY.market : _country, postalCode = param.postalCode;
    return {
        "@type": "PostalAddress",
        streetAddress: street,
        addressLocality: locality,
        addressRegion: region,
        postalCode: postalCode,
        addressCountry: country
    };
}
var setAmenities = function(amenities) {
    return amenities.map(function(amenity) {
        return {
            "@type": "LocationFeatureSpecification",
            value: "True",
            name: amenity.name
        };
    });
};
var mappers_mapJsonLdTypeDetail = function(accommodation, addressParam) {
    var accommodationType = accommodation.accommodationType, name = accommodation.name, url = accommodation.url, image = accommodation.photo, description = accommodation.description, latitude = accommodation.latitude, longitude = accommodation.longitude, rating = accommodation.rating, facilities = accommodation.facilities;
    return {
        "@context": "http://schema.org",
        "@type": accommodationType.toLowerCase(),
        name: name,
        url: url,
        image: image,
        description: description,
        address: setAddress(addressParam),
        geo: {
            "@type": "GeoCoordinates",
            latitude: latitude,
            longitude: longitude
        },
        starRating: {
            "@type": "http://schema.org/Rating",
            ratingValue: rating
        },
        amenityFeature: setAmenities(facilities)
    };
};
var mappers_mapJsonLdBreadcrumb = function(param) {
    var urlHome = param.urlHome, urlList = param.urlList, urlDetail = param.urlDetail, listTitle = param.listTitle, detailTitle = param.detailTitle;
    return {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
            {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: urlHome
            },
            {
                "@type": "ListItem",
                position: 2,
                name: listTitle,
                item: urlList
            },
            {
                "@type": "ListItem",
                position: 3,
                name: detailTitle,
                item: urlDetail
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./client/components/JsonLd/utils.js





function setJsonLdBreadcrumb(params) {
    return JSON.stringify(mapJsonLdBreadcrumb(params));
}
function setJsonLdAccommodation(accommodation, addressParam) {
    return JSON.stringify(mapJsonLdTypeDetail(accommodation, addressParam));
}
function setSameAsByMarket(market) {
    var linkedinMarket = market !== "es" && market !== "de" && market !== "fr" && market !== "pt" ? "https://www.linkedin.com/company/stayforlong" : "https://".concat(market, ".linkedin.com/company/stayforlong");
    var twitterMarket = market === "es" ? "https://twitter.com/stayforlong_es" : "https://twitter.com/stayforlong";
    return (0,_to_consumable_array/* default */.Z)(sameAs).concat([
        linkedinMarket,
        twitterMarket
    ]);
}
function getJsonLd(market) {
    var jsonLdMarket = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, jsonld), {
        sameAs: setSameAsByMarket(market)
    });
    if (!descriptions[market]) {
        return JSON.stringify(jsonLdMarket);
    }
    return JSON.stringify((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, jsonLdMarket), {
        description: descriptions[market]
    }));
}


/***/ }),

/***/ 77555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Home_Head; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ./src/constants/business.js
var business = __webpack_require__(17003);
// EXTERNAL MODULE: ./client/components/JsonLd/utils.js + 2 modules
var utils = __webpack_require__(59896);
// EXTERNAL MODULE: ./lib/utils/page.ts
var page = __webpack_require__(96011);
// EXTERNAL MODULE: ./src/comps/HrefLangs/index.js + 1 modules
var HrefLangs = __webpack_require__(15363);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(49177);
;// CONCATENATED MODULE: ./client/pages/Home/messages.js

var messages = (0,lib/* defineMessages */.vU)({
    title: {
        id: "page.home.title"
    },
    description: {
        id: "page.home.description"
    },
    bannerText: {
        id: "banner.text"
    },
    bannerTitle: {
        id: "banner.title"
    },
    homeTitle: {
        id: "hero.best-hotels-for-your-holidays"
    }
});
/* harmony default export */ var Home_messages = (messages);

// EXTERNAL MODULE: ./src/hooks/useMarket.ts
var useMarket = __webpack_require__(59806);
;// CONCATENATED MODULE: ./client/pages/Home/Head.tsx










var Head = function(props) {
    var _pathname = props.pathname, pathname = _pathname === void 0 ? "" : _pathname;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,useMarket/* useMarket */.A)(), language = ref.language, market = ref.market, subdomain = ref.subdomain, topdomain = ref.topdomain;
    var title = "".concat(business/* BRAND_NAME_TITLE */.W_, ": ").concat(intl.formatMessage(Home_messages.title));
    var description = intl.formatMessage(Home_messages.description, {
        brand: business/* BRAND_NAME_TITLE */.W_
    });
    var canonicalURL = (0,page/* buildCanonicalURL */._L)({
        market: market,
        language: language,
        pathname: pathname,
        subdomain: subdomain,
        topdomain: topdomain
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: canonicalURL
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        children: (0,utils/* getJsonLd */.ZE)(market)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HrefLangs/* default */.Z, {
                pathname: pathname
            })
        ]
    });
};
/* harmony default export */ var Home_Head = (Head);


/***/ }),

/***/ 67497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ homev2; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/ds/src/index.ts + 108 modules
var src = __webpack_require__(79000);
// EXTERNAL MODULE: ../../packages/uikit/src/index.ts + 161 modules
var uikit_src = __webpack_require__(41281);
// EXTERNAL MODULE: ./client/components/Footer/index.tsx
var Footer = __webpack_require__(3066);
// EXTERNAL MODULE: ./client/components/Header/index.tsx + 3 modules
var Header = __webpack_require__(56411);
// EXTERNAL MODULE: ./client/pages/Home/Head.tsx + 1 modules
var Head = __webpack_require__(77555);
// EXTERNAL MODULE: ./src/comps/BuilderModal/index.tsx + 2 modules
var BuilderModal = __webpack_require__(69383);
// EXTERNAL MODULE: ../../node_modules/next/script.js
var script = __webpack_require__(45847);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./src/hooks/useMarket.ts
var useMarket = __webpack_require__(59806);
;// CONCATENATED MODULE: ./src/comps/Maze/index.tsx




var Maze = function() {
    var ref;
    var market = (0,useMarket/* useMarket */.A)().market;
    if (!((ref = "1f689476-14f3-4098-9ac0-4689e6e9b2b7") === null || ref === void 0 ? void 0 : ref.length)) return null;
    if (market !== "us" && market !== "uk") return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        id: "maze",
        children: "\n          (function (m, a, z, e) {\n            var s, t;\n            try {\n              t = m.sessionStorage.getItem('maze-us');\n            } catch (err) {}\n\n            if (!t) {\n              t = new Date().getTime();\n              try {\n                m.sessionStorage.setItem('maze-us', t);\n              } catch (err) {}\n            }\n\n            s = a.createElement('script');\n            s.src = z + '?apiKey=' + e;\n            s.async = true;\n            a.getElementsByTagName('head')[0].appendChild(s);\n            m.mazeUniversalSnippetApiKey = e;\n          })(window, document, 'https://snippet.maze.co/maze-universal-loader.js', '".concat("1f689476-14f3-4098-9ac0-4689e6e9b2b7", "');\n        ")
    });
};
/* harmony default export */ var comps_Maze = (Maze);

// EXTERNAL MODULE: ./src/comps/Page/index.js + 4 modules
var Page = __webpack_require__(77288);
// EXTERNAL MODULE: ./src/constants/routes.js
var routes = __webpack_require__(54166);
// EXTERNAL MODULE: ./src/constants/subscriptionSources.js
var subscriptionSources = __webpack_require__(4077);
// EXTERNAL MODULE: ./src/context/search/index.tsx
var search = __webpack_require__(33500);
// EXTERNAL MODULE: ./src/context/topDestinations/index.tsx
var topDestinations = __webpack_require__(27606);
// EXTERNAL MODULE: ./src/hooks/useKafkaEvent/index.ts
var useKafkaEvent = __webpack_require__(96128);
// EXTERNAL MODULE: ./src/hooks/useKafkaEvent/constants.ts
var constants = __webpack_require__(18935);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ./src/types/search.ts
var types_search = __webpack_require__(50728);
// EXTERNAL MODULE: ./src/hooks/useDevice/index.ts
var useDevice = __webpack_require__(72731);
// EXTERNAL MODULE: ./src/types/device.ts
var device = __webpack_require__(68686);
// EXTERNAL MODULE: ./client/utils.js + 2 modules
var utils = __webpack_require__(30796);
// EXTERNAL MODULE: ./lib/storage.js
var storage = __webpack_require__(59588);
// EXTERNAL MODULE: ./src/hooks/useSearch.ts
var useSearch = __webpack_require__(36796);
// EXTERNAL MODULE: ./src/comps/OmniSearch/index.tsx + 1 modules
var OmniSearch = __webpack_require__(77427);
;// CONCATENATED MODULE: ./src/pages/homeV2/Search/Omnisearch/index.tsx




var Omnisearch_OmniSearch = function(param) {
    var mode = param.mode, onClick = param.onClick, disabled = param.disabled;
    var oldSearchUrl = (0,useSearch/* useSearch */.R)().oldSearchUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OmniSearch/* default */.Z, {
        mode: mode,
        onClick: onClick,
        preventNavigation: false,
        searchUrl: oldSearchUrl,
        disabled: disabled
    });
};

// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ./src/pages/homeV2/Search/OmnisearchBtn/styles.module.css
var styles_module = __webpack_require__(47590);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/pages/homeV2/Search/OmnisearchBtn/index.tsx







function OmnisearchBtn(param) {
    var onClick = param.onClick;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* BottomSheet */.R1, {
        snapPoints: [],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet.Trigger */.R1.Trigger, {
                className: (styles_module_default()).searchSummary,
                "data-testid": "omnisearch-btn",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Omnisearch_OmniSearch, {
                    mode: types_search/* SearchMode.Borderless */.N3.Borderless,
                    disabled: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet.Content */.R1.Content, {
                title: intl.formatMessage({
                    id: "modify.search"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Omnisearch_OmniSearch, {
                    mode: types_search/* SearchMode.Full */.N3.Full,
                    onClick: onClick
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/pages/homeV2/Search/styles.module.css
var Search_styles_module = __webpack_require__(88364);
var Search_styles_module_default = /*#__PURE__*/__webpack_require__.n(Search_styles_module);
// EXTERNAL MODULE: ./src/hooks/useSuggesterSearch/index.tsx
var useSuggesterSearch = __webpack_require__(90241);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(12524);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useIntersection.js
var useIntersection = __webpack_require__(26182);
// EXTERNAL MODULE: ./src/comps/Molecules/Paxes/helpers.ts
var helpers = __webpack_require__(12048);
// EXTERNAL MODULE: ./src/comps/Molecules/Suggester/MobilePill/index.tsx
var MobilePill = __webpack_require__(35213);
// EXTERNAL MODULE: ./src/comps/SearchButton/index.tsx
var SearchButton = __webpack_require__(50138);
// EXTERNAL MODULE: ./src/context/search/utils.ts
var search_utils = __webpack_require__(74774);
// EXTERNAL MODULE: ./src/comps/ConnectedDatePicker/index.tsx
var ConnectedDatePicker = __webpack_require__(30887);
;// CONCATENATED MODULE: ./src/pages/homeV2/Search/DatePicker/index.tsx




function DatePicker() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-testid": "datepicker-wrapper",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectedDatePicker/* default */.Z, {
            mode: types_search/* SearchMode.Full */.N3.Full
        })
    });
}

// EXTERNAL MODULE: ./src/pages/homeV2/Search/Paxes/styles.module.css
var Paxes_styles_module = __webpack_require__(4363);
var Paxes_styles_module_default = /*#__PURE__*/__webpack_require__.n(Paxes_styles_module);
// EXTERNAL MODULE: ./src/comps/PaxesConnected/index.tsx
var PaxesConnected = __webpack_require__(17181);
;// CONCATENATED MODULE: ./src/pages/homeV2/Search/Paxes/index.tsx





function Paxes() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-testid": "paxes-wrapper",
        className: (Paxes_styles_module_default()).paxesWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaxesConnected/* default */.Z, {
            mode: types_search/* SearchMode.Full */.N3.Full
        })
    });
}

// EXTERNAL MODULE: ./src/comps/SuggesterConnected/index.tsx
var SuggesterConnected = __webpack_require__(86998);
;// CONCATENATED MODULE: ./src/pages/homeV2/Search/Suggester/index.tsx




function Suggester() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggesterConnected/* default */.Z, {
        className: "suggester-wrapper",
        mode: types_search/* SearchMode.Full */.N3.Full
    });
}

// EXTERNAL MODULE: ./src/pages/homeV2/Search/OmnisearchMobile/styles.module.css
var OmnisearchMobile_styles_module = __webpack_require__(69553);
var OmnisearchMobile_styles_module_default = /*#__PURE__*/__webpack_require__.n(OmnisearchMobile_styles_module);
;// CONCATENATED MODULE: ./src/pages/homeV2/Search/OmnisearchMobile/index.tsx


















function OmnisearchMobile(param) {
    var searchUrl = param.searchUrl, onClick = param.onClick;
    var mobileSuggesterRef = (0,react.useRef)(null);
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,useSearch/* useSearch */.R)(), draftRooms = ref.draftRooms, draftCheckin = ref.draftCheckin, draftCheckout = ref.draftCheckout, draftLocation = ref.draftLocation;
    var paxesPlain = (0,helpers/* getPaxes */.L5)(draftRooms);
    var suggestionText = (0,search_utils/* isProperty */.IC)(draftLocation === null || draftLocation === void 0 ? void 0 : draftLocation.Type) ? draftLocation === null || draftLocation === void 0 ? void 0 : draftLocation.Text : draftLocation === null || draftLocation === void 0 ? void 0 : draftLocation.Description;
    var mobileIntersection = (0,useIntersection/* default */.Z)(mobileSuggesterRef, {
        root: null,
        rootMargin: "0px",
        threshold: 0.15
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (OmnisearchMobile_styles_module_default()).searchMobile,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Suggester, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePicker, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paxes, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchButton/* default */.Z, {
                        searchUrl: searchUrl,
                        onClick: onClick,
                        fullWidth: true,
                        preventNavigation: false
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: mobileSuggesterRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((OmnisearchMobile_styles_module_default()).mobileBottomSheet, (0,_define_property/* default */.Z)({}, (OmnisearchMobile_styles_module_default()).appear, mobileIntersection && mobileIntersection.intersectionRatio <= 0)),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* BottomSheet */.R1, {
                    snapPoints: [],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MobilePill/* default */.Z, {
                            text: suggestionText,
                            checkIn: draftCheckin,
                            checkOut: draftCheckout,
                            paxes: paxesPlain
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet.Content */.R1.Content, {
                            title: intl.formatMessage({
                                id: "modify.search"
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Omnisearch_OmniSearch, {
                                mode: types_search/* SearchMode.Full */.N3.Full
                            })
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/pages/homeV2/Search/index.tsx















var Views;
(function(Views) {
    Views["Desktop"] = "desktop";
    Views["Tablet"] = "tablet";
    Views["Mobile"] = "mobile";
})(Views || (Views = {}));
var getView = function(param) {
    var activeBreakpoint = param.activeBreakpoint;
    if (activeBreakpoint >= device/* BreakpointSizes.L */.a.L) {
        return Views.Desktop;
    }
    if (activeBreakpoint >= device/* BreakpointSizes.M */.a.M) {
        return Views.Tablet;
    }
    return Views.Mobile;
};
var _obj;
var componentMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, Views.Desktop, function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Omnisearch_OmniSearch, {
        mode: types_search/* SearchMode.Borderless */.N3.Borderless,
        onClick: onClick
    });
}), (0,_define_property/* default */.Z)(_obj, Views.Tablet, function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OmnisearchBtn, {
        onClick: onClick
    });
}), (0,_define_property/* default */.Z)(_obj, Views.Mobile, function(param) {
    var onClick = param.onClick, searchUrl = param.searchUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OmnisearchMobile, {
        searchUrl: searchUrl,
        onClick: onClick
    });
}), _obj);
function Search() {
    var ref = (0,useSearch/* useSearch */.R)(), oldSearchUrl = ref.oldSearchUrl, draftLocation = ref.draftLocation;
    var addUserLastSearch = (0,useSuggesterSearch/* useSuggesterSearch */.d)().addUserLastSearch;
    var href = oldSearchUrl.href;
    var activeBreakpoint = (0,useDevice/* useDevice */.F)().activeBreakpoint;
    var search = (0,_object_spread/* default */.Z)({}, href.query, draftLocation);
    var saveSearch = function(query) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
        var paxes = (0,utils/* getPaxesfromUrlParams */.ch)({
            adults: href.query.adults,
            children: href.query.children
        });
        if (!(query === null || query === void 0 ? void 0 : query.ID)) return;
        var ref16, ref17, ref18, ref19;
        addUserLastSearch({
            location: (0,_object_spread/* default */.Z)({
                id: query.ID,
                country: query.Country,
                type: query.Type,
                slug: query.slug,
                text: query.Text,
                description: query.Description,
                citySlug: query.citySlug,
                coordinates: {
                    lat: query.Coordinate.lat,
                    lon: query.Coordinate.lon
                }
            }, query.BoxShape && {
                boxShape: {
                    topLeft: {
                        lat: (ref16 = (ref = query.BoxShape) === null || ref === void 0 ? void 0 : (ref1 = ref.TopLeft) === null || ref1 === void 0 ? void 0 : ref1.Lat) !== null && ref16 !== void 0 ? ref16 : (ref2 = query.BoxShape) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.topLeft) === null || ref3 === void 0 ? void 0 : ref3.lat,
                        lon: (ref17 = (ref4 = query.BoxShape) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.TopLeft) === null || ref5 === void 0 ? void 0 : ref5.Lon) !== null && ref17 !== void 0 ? ref17 : (ref6 = query.BoxShape) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.topLeft) === null || ref7 === void 0 ? void 0 : ref7.lon
                    },
                    bottomRight: {
                        lat: (ref18 = (ref8 = query.BoxShape) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.BottomRight) === null || ref9 === void 0 ? void 0 : ref9.Lat) !== null && ref18 !== void 0 ? ref18 : (ref10 = query.BoxShape) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.bottomRight) === null || ref11 === void 0 ? void 0 : ref11.lat,
                        lon: (ref19 = (ref12 = query.BoxShape) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.BottomRight) === null || ref13 === void 0 ? void 0 : ref13.Lon) !== null && ref19 !== void 0 ? ref19 : (ref14 = query.BoxShape) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.bottomRight) === null || ref15 === void 0 ? void 0 : ref15.lon
                    }
                }
            }),
            dates: {
                ci: query.checkin,
                co: query.checkout
            },
            paxes: paxes
        });
    };
    var handleSearch = function(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        var paxes = (0,utils/* getPaxesfromUrlParams */.ch)({
            adults: href.query.adults,
            children: href.query.children
        });
        (0,storage/* setSearchParamsLocalStorage */.Im)({
            checkIn: href.query.checkin,
            checkOut: href.query.checkout,
            adults: paxes.adults,
            children: paxes.children
        });
        saveSearch(search);
    };
    var view = getView({
        activeBreakpoint: activeBreakpoint
    });
    var Component = componentMap[view];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-testid": "search-wrapper",
        className: (Search_styles_module_default()).content,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
            onClick: handleSearch,
            searchUrl: oldSearchUrl
        })
    });
}

// EXTERNAL MODULE: ./src/pages/homeV2/styles.module.css
var homeV2_styles_module = __webpack_require__(24480);
var homeV2_styles_module_default = /*#__PURE__*/__webpack_require__.n(homeV2_styles_module);
;// CONCATENATED MODULE: ./pages/homev2/index.tsx


















var pageId = routes/* routes.home.page */._.home.page;
function HomeV2(param) {
    var config = param.config, amazingDestinations = param.amazingDestinations, topDestinationsJSON = param.topDestinationsJSON, bannersJSON = param.bannersJSON, lastSeenJSON = param.lastSeenJSON, ancillariesJSON = param.ancillariesJSON;
    var ref = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: routes/* routes.home.page */._.home.page
    }), sendTopDestinationEvent = ref.sendEvent;
    var ref1 = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: routes/* routes.home.page */._.home.page,
        eventName: "click"
    }), sendClickBannerEvent = ref1.sendEvent;
    var ref2 = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: pageId
    }), sendKafkaClick = ref2.sendEvent;
    var onPropertyClick = function(propertyId) {
        sendKafkaClick({
            section: constants/* SECTIONS.HOTELS_SEEN */.SA.HOTELS_SEEN
        }, {
            id_property: propertyId
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.Z, {
        config: config,
        pageId: pageId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_Maze, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(search/* SearchProvider */.X, {
                location: null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(topDestinations/* TopDestinationsProvider */.I, {
                    value: {
                        destinations: amazingDestinations || []
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (homeV2_styles_module_default()).homeContainer,
                        "data-testid": "home-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(uikit_src.Banner.Announcement, {
                                bannersJSON: bannersJSON,
                                "data-testid": "topbar-section"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                                pageId: pageId,
                                hasLogin: true,
                                ancillariesJSON: ancillariesJSON
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(uikit_src.Banner.Hero, {
                                bannersJSON: bannersJSON,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Search, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (homeV2_styles_module_default()).trustpilot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(uikit_src.TrustPilotWidget, {
                                            theme: "dark"
                                        })
                                    })
                                ]
                            }),
                            lastSeenJSON && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: (homeV2_styles_module_default()).hotelsSeenSection,
                                "data-testid": "hotels-seen-section",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (homeV2_styles_module_default()).sectionContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(uikit_src.LastSeen, {
                                        lastSeenPropertiesJSON: lastSeenJSON,
                                        onPropertyClick: onPropertyClick
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(uikit_src.Advantages, {}),
                            topDestinationsJSON && /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* HSection */.fu, {
                                justify: "center",
                                paddingTop: "var(--size-40)",
                                paddingBottom: "var(--size-40)",
                                paddingLeftRight: "var(--size-16)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(uikit_src.TopDestinations, {
                                    topDestinationsJSON: topDestinationsJSON,
                                    onDestinationClick: function(extraPayload) {
                                        return sendTopDestinationEvent({
                                            section: constants/* SECTIONS.TOP_DESTINATIONS */.SA.TOP_DESTINATIONS
                                        }, extraPayload);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(uikit_src.Banner.Block, {
                                bannersJSON: bannersJSON,
                                "data-testid": "release-banner-section",
                                onClick: function() {
                                    return sendClickBannerEvent({
                                        section: constants/* SECTIONS.BANNER_BLOCK */.SA.BANNER_BLOCK
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: (homeV2_styles_module_default()).reviewsSection,
                                "data-testid": "reviews-section",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (homeV2_styles_module_default()).sectionContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(uikit_src.Reviews, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: (homeV2_styles_module_default()).aboutUsSection,
                                "data-testid": "aboutus-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (homeV2_styles_module_default()).sectionContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(uikit_src.AboutUs, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(uikit_src.SubscriptionBox, {
                                source: subscriptionSources/* SUBSCRIPTION_BOX_HOME_PAGE */.yW
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderModal/* default */.Z, {
                isSubscriptionModalActive: true
            })
        ]
    });
}
HomeV2.pageId = pageId;
HomeV2.pagePathView = "/homeV2";
var __N_SSP = true;
/* harmony default export */ var homev2 = (HomeV2);


/***/ }),

/***/ 69383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ comps_BuilderModal; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@builder.io/react/dist/builder-react.es5.js
var builder_react_es5 = __webpack_require__(96204);
// EXTERNAL MODULE: ./client/components/Modal/index.js
var Modal = __webpack_require__(38997);
// EXTERNAL MODULE: ./client/components/Modal/constants.js
var constants = __webpack_require__(61673);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(94449);
// EXTERNAL MODULE: ./src/constants/subscriptionSources.js
var subscriptionSources = __webpack_require__(4077);
// EXTERNAL MODULE: ./src/effects/SubscriptionStatus/actions.js
var actions = __webpack_require__(92186);
// EXTERNAL MODULE: ./src/effects/SubscriptionStatus/constants.js
var SubscriptionStatus_constants = __webpack_require__(26111);
// EXTERNAL MODULE: ./src/effects/SubscriptionStatus/selectors.js
var selectors = __webpack_require__(72926);
// EXTERNAL MODULE: ./src/hooks/useMarket.ts
var useMarket = __webpack_require__(59806);
// EXTERNAL MODULE: ./client/helpers/Form/index.ts + 1 modules
var Form = __webpack_require__(5766);
// EXTERNAL MODULE: ../../packages/ds/src/index.ts + 108 modules
var src = __webpack_require__(79000);
// EXTERNAL MODULE: ../../packages/icons/lib/IconArrowRight.tsx
var IconArrowRight = __webpack_require__(75300);
// EXTERNAL MODULE: ./src/comps/Molecules/SubscriptionModal/styles.module.css
var styles_module = __webpack_require__(26624);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./client/components/MessageTerms/index.tsx
var MessageTerms = __webpack_require__(68984);
// EXTERNAL MODULE: ./src/comps/Atom/Inputs/Input/Input.tsx
var Input = __webpack_require__(69475);
// EXTERNAL MODULE: ./client/components/FormErrorMessage/messages.ts
var messages = __webpack_require__(25655);
// EXTERNAL MODULE: ../../packages/react-context/src/index.tsx + 11 modules
var react_context_src = __webpack_require__(67048);
;// CONCATENATED MODULE: ./src/comps/Molecules/SubscriptionModal/index.tsx











function SubscriptionModal(props) {
    var status = props.status, onSubscribe = props.onSubscribe;
    var ref = (0,react.useState)([]), errors = ref[0], setErrors = ref[1];
    var ref1 = (0,react.useState)(""), email = ref1[0], setEmail = ref1[1];
    var ref2 = (0,react.useState)(false), formSubmitted = ref2[0], setFormSubmitted = ref2[1];
    var i18n = (0,react_context_src/* useS4LContext */.ms)().i18n;
    if (status === SubscriptionStatus_constants/* SUBSCRIBED */.Wx) {
        return null;
    }
    var handleChangeEmail = function(newEmail) {
        setEmail(newEmail);
    };
    var handleSubmit = function(e) {
        e.preventDefault();
        setFormSubmitted(true);
        if ((0,Form/* validateEmail */.oH)(email)) {
            setErrors([
                {
                    id: "validEmail"
                }
            ]);
            return;
        }
        setErrors([]);
        onSubscribe(email);
    };
    if (status === SubscriptionStatus_constants/* UNSUBSCRIBED */.$y) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).subscriptionModalBase,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                    className: (styles_module_default()).subscriptionModalTitle,
                    children: i18n.formatMessage({
                        id: "global.modal-home-subscription-title"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (styles_module_default()).subscriptionModalSubTitle,
                    children: i18n.formatMessage({
                        id: "global.modal-home-subscription-subtitle"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    className: (styles_module_default()).subscriptionForm,
                    "data-testid": "subscription-form",
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            errors: errors.map(function(error) {
                                var message = messages/* default */.Z[error.id];
                                return i18n.formatMessage(message);
                            }),
                            label: i18n.formatMessage({
                                id: "global.email"
                            }),
                            value: email,
                            onChange: handleChangeEmail,
                            disabled: formSubmitted && errors.length === 0
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Button */.zx, {
                            disabled: formSubmitted && errors.length === 0,
                            variant: "filled-rounded",
                            trailingIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrowRight/* IconArrowRight */.E, {}),
                            size: "small",
                            fullWidth: true,
                            type: "submit",
                            children: i18n.formatMessage({
                                id: "global.modal-home-subscription-cta"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).termsContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageTerms/* default */.Z, {
                        isEmail: true
                    })
                })
            ]
        });
    }
    return null;
}

// EXTERNAL MODULE: ../../node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(21805);
// EXTERNAL MODULE: ./src/constants/cookies.ts
var cookies = __webpack_require__(42290);
;// CONCATENATED MODULE: ./src/comps/BuilderModal/utils.ts


function setSubscriptionModalClosedCookie() {
    js_cookie/* default.set */.Z.set(cookies/* COOKIE_SUBSCRIPTION_MODAL_CLOSED */.B_, "true", {
        expires: cookies/* COOKIE_EXP_7D */.ck
    });
}
function getSubscriptionModalClosedCookie() {
    return Boolean(js_cookie/* default.get */.Z.get(cookies/* COOKIE_SUBSCRIPTION_MODAL_CLOSED */.B_));
}

// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ./src/hooks/useBusiness.ts
var useBusiness = __webpack_require__(16153);
// EXTERNAL MODULE: ./src/constants/affiliates.ts
var affiliates = __webpack_require__(1620);
;// CONCATENATED MODULE: ./src/comps/BuilderModal/index.tsx

















var BuilderModal = function(param) {
    var _isSubscriptionModalActive = param.isSubscriptionModalActive, isSubscriptionModalActive = _isSubscriptionModalActive === void 0 ? false : _isSubscriptionModalActive;
    var ref = (0,useMarket/* useMarket */.A)(), locale = ref.locale, market = ref.market, language = ref.language, feedbackMessageType = ref.feedbackMessageType;
    var affiliate = (0,useBusiness/* useBusiness */.i)().affiliate;
    var ref1 = (0,react.useState)(false), showBuilderModal = ref1[0], setShowBuilderModal = ref1[1];
    var ref2 = (0,react.useState)(false), showSubscriptionModal = ref2[0], setShowSubscriptionModal = ref2[1];
    var ref3 = (0,react.useState)(), content = ref3[0], setContent = ref3[1];
    var allMarkets = "all";
    var modalId = "en-modal";
    var dispatch = (0,es/* useDispatch */.I0)();
    var subscriptionStatus = (0,es/* useSelector */.v9)(selectors/* getSubscriptionStatus */.ku);
    var handleSubscribe = function(emailToSubscribe) {
        setSubscriptionModalClosedCookie();
        dispatch((0,actions/* subscribeRequestAction */.k2)({
            hash: emailToSubscribe,
            language: language,
            market: market,
            feedbackMessageType: feedbackMessageType,
            source: subscriptionSources/* SUBSCRIPTION_MODAL_HOME_PAGE */.lI
        }));
    };
    var handleCloseSubscriptionModal = function() {
        setShowSubscriptionModal(false);
        setSubscriptionModalClosedCookie();
    };
    var isAffiliateEmail = affiliate && affiliates/* AFFILIATES_EMAIL.includes */.h4.includes(affiliate);
    var router = (0,next_router.useRouter)();
    var _query = router.query, builderModal = _query.builder_modal;
    var getModal = (0,react.useCallback)(function(marketToSearch) {
        return builder_react_es5/* builder.get */.fl.get(modalId, {
            url: window.location.pathname,
            userAttributes: {
                locale: locale
            },
            includeUnpublished: builderModal === "draft",
            options: {
                locale: locale
            },
            query: {
                "data.markets": {
                    $elemMatch: {
                        market: {
                            $regex: "^".concat(marketToSearch, "$"),
                            $options: "i"
                        }
                    }
                }
            }
        }).promise();
    }, [
        locale,
        builderModal
    ]);
    (0,react.useEffect)(function() {
        getModal(market).then(function(res) {
            if (res) {
                return res;
            }
            return getModal(allMarkets);
        }).then(function(res) {
            setContent(res);
            setShowBuilderModal(!!res);
        });
        if (isSubscriptionModalActive && !isAffiliateEmail && !showBuilderModal && !getSubscriptionModalClosedCookie()) {
            setShowSubscriptionModal(true);
        }
    }, [
        getModal,
        market,
        showBuilderModal,
        subscriptionStatus,
        isSubscriptionModalActive,
        isAffiliateEmail, 
    ]);
    if (!showBuilderModal && !showSubscriptionModal) {
        return null;
    }
    if (showSubscriptionModal && subscriptionStatus === SubscriptionStatus_constants/* UNSUBSCRIBED */.$y) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
            show: showSubscriptionModal,
            handleClose: handleCloseSubscriptionModal,
            maxWidth: "430px",
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "global.modal-home-subscription-header"
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionModal, {
                status: subscriptionStatus,
                onSubscribe: handleSubscribe
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        show: showBuilderModal,
        handleClose: function() {
            return setShowBuilderModal(false);
        },
        variant: constants/* VARIANT_MID_SCREEN */.lJ,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_react_es5/* BuilderComponent */.VD, {
            model: modalId,
            content: content,
            locale: locale
        })
    });
};
/* harmony default export */ var comps_BuilderModal = (BuilderModal);


/***/ }),

/***/ 15363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ comps_HrefLangs; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/constants/environment.js
var environment = __webpack_require__(65003);
;// CONCATENATED MODULE: ./lib/domain.js

function buildHref(param) {
    var country = param.country, _pathname = param.pathname, pathname = _pathname === void 0 ? "" : _pathname;
    var subDomain = country.subdomain || "www";
    var topDomain = country.topdomain || "com";
    var queryParams = !country.subdomain && !country.topdomain ? "?market=".concat(country.market, "&lang=").concat(country.language) : "";
    return "https://".concat(subDomain, ".").concat(environment/* DOMAIN */.yK, ".").concat(topDomain).concat(pathname).concat(queryParams);
}

// EXTERNAL MODULE: ./src/constants/countries.ts
var countries = __webpack_require__(83404);
// EXTERNAL MODULE: ./client/components/CountrySelector/index.tsx + 2 modules
var CountrySelector = __webpack_require__(59813);
;// CONCATENATED MODULE: ./src/comps/HrefLangs/index.js







var HrefLangs = function(param) {
    var pathname = param.pathname;
    var hrefDefault = buildHref({
        country: countries/* DEFAULT_COUNTRY */.U,
        pathname: pathname
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "alternate",
                hrefLang: "x-default",
                href: hrefDefault
            }),
            Object.keys(countries/* COUNTRIES */.o).filter(function(key) {
                return key !== "zz" && !CountrySelector/* NEW_MARKETS.includes */.p.includes(key);
            }).map(function(key) {
                var country = countries/* COUNTRIES */.o[key];
                var href = buildHref({
                    country: country,
                    pathname: pathname
                });
                var hrefLang = countries/* COUNTRIES */.o[key].market === "no" ? "no" : country.locale;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "alternate",
                    hrefLang: hrefLang,
                    href: href
                }, key);
            })
        ]
    });
};
HrefLangs.propTypes = {
    pathname: (prop_types_default()).string.isRequired
};
/* harmony default export */ var comps_HrefLangs = (HrefLangs);


/***/ }),

/***/ 26624:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subscriptionModalBase":"styles_subscriptionModalBase__tTDY6","subscriptionForm":"styles_subscriptionForm__0SvNd","subscriptionInput":"styles_subscriptionInput__rBq9P","termsContainer":"styles_termsContainer__RRxz1","subscriptionModalTitle":"styles_subscriptionModalTitle__h2f84 system_titleXs__EJJjY","subscriptionModalSubTitle":"styles_subscriptionModalSubTitle__PQjrK system_textBodyM__ZzPjG","successContainer":"styles_successContainer__cIEGQ"};

/***/ }),

/***/ 47590:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"styles_buttonWrapper__JsjRp","searchSummary":"styles_searchSummary__5jIHm"};

/***/ }),

/***/ 69553:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchMobile":"styles_searchMobile__uCXFq","mobileBottomSheet":"styles_mobileBottomSheet__cBb4N","appear":"styles_appear__FcyDK"};

/***/ }),

/***/ 4363:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"paxesWrapper":"styles_paxesWrapper__vrwma"};

/***/ }),

/***/ 88364:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(min-width: 768px) and (max-width: 1023px)","desktop":"(min-width: 1024px)","content":"styles_content__ClFdo","full":"styles_full__iSWiI"};

/***/ }),

/***/ 24480:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(min-width: 768px)","desktop":"(min-width: 1024px)","homeContainer":"styles_homeContainer__8bHyo","section":"styles_section__9who9","sectionContainer":"styles_sectionContainer__ZfZnu","titleSection":"styles_titleSection__BoBvE styles_section__9who9","searchSection":"styles_searchSection__Smf8W","keyFeaturesSection":"styles_keyFeaturesSection__2xRCe","aboutUsSection":"styles_aboutUsSection__JEQSN","hotelsSeenSection":"styles_hotelsSeenSection____gAw","reviewsSection":"styles_reviewsSection__922mo","trustpilot":"styles_trustpilot__MyZ7z"};

/***/ })

}]);